export function compose() {
    var systems = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        systems[_i] = arguments[_i];
    }
    return function (game) {
        var cleanups = systems.map(function (sys) { return sys(game); });
        return function () {
            cleanups.forEach(function (cleanup) { return cleanup(); });
        };
    };
}
//# sourceMappingURL=compose.js.map